import { HealaFillLogoLoader } from "@/components/heala-loader";

export function LoadingView() {
  return (
    <div className="rounded-lg bg-white h-screen">
      <HealaFillLogoLoader /> {/* FillLogoLoader */}
    </div>
  );
}
